export interface UserDto {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  emailConfirmed: boolean;
  roles: string[];
  createdAt: string;
  lastSignInAt?: string;
}

export enum UserRole {
  Owner = 'Owner',
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  User = 'User'
}

export const RoleHierarchy: Record<string, number> = {
  [UserRole.Owner]: 3,
  [UserRole.SuperAdmin]: 2,
  [UserRole.Admin]: 1,
  [UserRole.User]: 0
};

export const hasRole = (userRoles: string[] | undefined, requiredRole: UserRole): boolean => {
  if (!userRoles) return false;
  const userHighestLevel = Math.max(...userRoles.map(r => RoleHierarchy[r] || 0));
  return userHighestLevel >= RoleHierarchy[requiredRole];
};

export interface PagedUsersResponse {
  users: UserDto[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface CreateUserRequest {
  email: string;
  password: string;
  firstName?: string;
  lastName?: string;
  emailConfirmed: boolean;
  roles: string[];
}

export interface UpdateUserRequest {
  email?: string;
  firstName?: string;
  lastName?: string;
  emailConfirmed?: boolean;
}

export interface UpdateUserRolesRequest {
  roles: string[];
}

export interface ResetPasswordRequest {
  newPassword: string;
}
